import React from 'react'
import {
  Button,
  Container,
  Link,
  ListContainer,
  NoSsr,
  TextTitle,
  TextBody,
  VariantList,
  Image
} from '@pmi/pmi-iqos-ds-react'
import {
  Price,
  LazyImage,
  BazaarVoice,
  Assets,
  Badges
} from '@pmi/pmi-iqos-shared-react'
import { AddToCartButton } from '@dcx-common/components'

const ProductCardGeneric = ({
  translations,
  href = '',
  stock,
  images,
  title,
  shortDescription,
  price,
  listPrice,
  currency,
  options,
  loading,
  buttonAddToCartLabel,
  buttonAddToPreorderLabel,
  buttonViewPlanDetailsLabel,
  selectedOptionIndex,
  handleOnCardClick,
  handleAddToPreorder,
  handleAddToCart,
  handleChangeColor,
  handle3dClick,
  handlePDPClick,
  testingPrefix,
  alternativeBadges,
  bazaarVoiceProductId,
  isSubscription,
  handleViewPlanDetails,
  outOfStockAction,
  isPXP,
  isShortDescription
}) => {
  return (
    <Container
      fullWidth
      fullHeight
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.column}>
      <Container fullWidth p="4" bg={Container.backgrounds.hardWhite}>
        <Container fullWidth>
          <Container
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.center}
            position={Container.positions.relative}
            fullWidth
            onClickHandler={handleOnCardClick}>
            <NoSsr>
              <Badges
                badges={alternativeBadges}
                testingPrefix={`${testingPrefix}_Badge_CardAlternativeBadge`}
                href={href}
                position={Container.positions.absolute}
              />
              <Link
                href={href}
                newTab={false}
                underlined={false}
                data-testing={testingPrefix && `${testingPrefix}_Link_Card`}>
                <Container
                  height="56"
                  display={Container.displays.flex}
                  alignItems={Container.alignItemsValues.center}>
                  <LazyImage
                    src={images && images.length > 0 ? images[0].path : null}
                    bgLayer={false}
                  />
                </Container>
              </Link>
            </NoSsr>
          </Container>
        </Container>
        <NoSsr>
          <Container
            display={Container.displays.flex}
            flexDirection={Container.flexDirections.row}
            alignItems={Container.alignItemsValues.center}
            justifyContent={Container.justifyContentValues.between}>
            <Container
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.start}
              p={['0', '0', '0', '2']}>
              {options && options.length > 0 && (
                <VariantList
                  variants={options}
                  selectedVariantIndex={selectedOptionIndex}
                  handleVariantIndexChange={handleChangeColor}
                  size={[VariantList.sizes.m, VariantList.sizes.s]}
                  maxAmount={6}
                  seeMoreLink={href}
                  data-testing-prefix={testingPrefix}
                />
              )}
            </Container>
            {isPXP && handle3dClick && (
              <Link onClickHandler={handle3dClick}>
                <Container
                  display={Container.displays.flex}
                  alignItems={Container.alignItemsValues.center}>
                  {translations.tk_action3DLink}
                  <Container pl="1">
                    <Image
                      src={Assets.urls.icon3dFullScreen}
                      width="4"
                      height="4"
                    />
                  </Container>
                </Container>
              </Link>
            )}
          </Container>
        </NoSsr>
      </Container>
      <Container
        pt="4"
        display={Container.displays.flex}
        flexDirection={Container.flexDirections.column}
        justifyContent={Container.justifyContentValues.between}>
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}>
          <NoSsr>
            {isSubscription ? (
              <Container>
                {title && (
                  <Link
                    href={href}
                    newTab={false}
                    underlined={false}
                    data-testing={
                      testingPrefix && `${testingPrefix}_CardTitle`
                    }>
                    <TextTitle
                      heading={TextTitle.headings.h6}
                      data-testing={
                        testingPrefix && `${testingPrefix}_CardTitle`
                      }>
                      {title}
                    </TextTitle>
                  </Link>
                )}
              </Container>
            ) : (
              <Container>
                {title ? (
                  <Link
                    href={href}
                    newTab={false}
                    underlined={false}
                    data-testing={
                      testingPrefix && `${testingPrefix}_CardTitle`
                    }>
                    <TextTitle
                      heading={TextTitle.headings.h6}
                      data-testing={
                        testingPrefix && `${testingPrefix}_CardTitle`
                      }>
                      {title}
                    </TextTitle>
                  </Link>
                ) : (
                  options &&
                  options[selectedOptionIndex] &&
                  options[selectedOptionIndex].variantName &&
                  options[selectedOptionIndex].variantName.length > 0 && (
                    <Link
                      href={href}
                      newTab={false}
                      underlined={false}
                      data-testing={
                        testingPrefix && `${testingPrefix}_CardVariantName`
                      }>
                      <TextTitle
                        heading={TextTitle.headings.h6}
                        data-testing={
                          testingPrefix && `${testingPrefix}_CardVariantName`
                        }>
                        {options[selectedOptionIndex].variantName}
                      </TextTitle>
                    </Link>
                  )
                )}
              </Container>
            )}
          </NoSsr>
          {isShortDescription && (
            <Container pt="4">
              <TextBody
                size={TextBody.sizes.s}
                acceptsHtml
                value={shortDescription}
              />
            </Container>
          )}

          <Container pt="4">
            <TextTitle heading={TextTitle.headings.h6}>
              <Price
                size=""
                listPrice={listPrice}
                price={price}
                currency={currency}
                handleOnCardClick={handleOnCardClick}
                listPriceLabel={translations.tk_listPriceDescription}
                discountedPriceLabel={
                  translations.tk_discountedPriceDescription
                }
                taxLabel={translations.tk_withTax}
                data-testing={testingPrefix && `${testingPrefix}_CardPrice`}
              />
            </TextTitle>
          </Container>
          <NoSsr>
            {!isPXP && bazaarVoiceProductId && (
              <Container pt="2">
                <BazaarVoice
                  type={BazaarVoice.types.inlineRating}
                  productId={bazaarVoiceProductId}
                  data-testing-prefix={testingPrefix}
                />
              </Container>
            )}
          </NoSsr>
        </Container>
        <Container pt="8">
          <ListContainer xBetween={['4', '6']} yBetween="4">
            <AddToCartButton
              maxQty={stock}
              hasStock={!!stock}
              addToCartHandler={
                isSubscription ? handleViewPlanDetails : handleAddToCart
              }
              addToPreorderHandler={
                isSubscription ? handleViewPlanDetails : handleAddToPreorder
              }
              loading={loading}
              outOfStockLabel={translations.tk_outOfStock}
              addToCartLabel={
                isSubscription
                  ? buttonViewPlanDetailsLabel
                  : buttonAddToCartLabel
              }
              addToPreorderLabel={
                isSubscription
                  ? buttonViewPlanDetailsLabel
                  : buttonAddToPreorderLabel
              }
              addToPreorderLabelDisabled={
                translations.tk_buttonAddToPreorderDisabled
              }
              outOfStockAction={outOfStockAction}
              data-testing={
                testingPrefix && isSubscription
                  ? `${testingPrefix}_Button_ViewPlanDetails`
                  : `${testingPrefix}_Button_AddToCart`
              }
            />
            {isPXP && handlePDPClick && (
              <Button
                onClickHandler={handlePDPClick}
                text={translations.tk_buttonDetails}
                variant={Button.variants.secondary}
              />
            )}
          </ListContainer>
        </Container>
      </Container>
    </Container>
  )
}

export default ProductCardGeneric
